import { createApp } from 'vue'
import App from './App.vue'
// import Emitter from '@tiny-emitter'

const app = createApp(App)
//  app.config.globalProperties.$emitter = Emitter();
 app.mount('#app')
